export class MicroappFaultListFilter{
    general: string;
    start_date: string;
    end_date: string;
    priority: string;
    status: string;
    read: boolean;
}